// extracted by mini-css-extract-plugin
export var planCard = "_sl-0";
export var planList = "_sl-1";